export default __webpack_public_path__ + "static/media/puppyFemaleYellow.4caa970c.jpg";